import { SerializedStyles } from '@emotion/react';
import * as React from 'react';


/**
 * TabSelectDiv: a component that is tab-focusable (by hitting the tab key on the keyboard), and optionally
 * mouse-focusable. This div will tell you when it's selectedItem by enter key or mouse click via props.onSelect.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class TabSelectDiv extends React.PureComponent<{
  onSelect: () => void,
  rootCss?: SerializedStyles,
  style?: object,
  children?: React.ReactNode,
}> {
  private onMouseDowned = (event: React.MouseEvent<HTMLDivElement>) => this.props.onSelect();


  private onKeyDowned = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' /* Enter key */) {
      this.props.onSelect(); // Notify parent of event
    }
  };


  public render() {
    return (
      <div tabIndex={0}
           onKeyDown={this.onKeyDowned}
           onMouseDown={this.onMouseDowned}
           css={this.props.rootCss}
           style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}
